module.exports = __webpack_public_path__ + "img/img_download_android@2x.e366980d.png";